// Copyright (c) 2025 Annadaneshwar Yadawad. All rights reserved.
import './Marketing.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Testimonials = () => (
  <>
    <Header />
    <div className="testimonials-page">
      <h1 className="testimonials-title">What Our Users Say</h1>
      <div className="testimonials-list">
        <div className="testimonial-card">
          <p>“Servantica has transformed the way our team collaborates and leverages AI. The interface is stunning and easy to use!”</p>
          <span className="testimonial-author">— Priya S., Product Manager</span>
        </div>
        <div className="testimonial-card">
          <p>“The AI services are top-notch and the security gives us peace of mind. Highly recommended for any business.”</p>
          <span className="testimonial-author">— John D., CTO</span>
        </div>
        <div className="testimonial-card">
          <p>“I love how everything is in one place. File sharing, messaging, and AI tools all work seamlessly together.”</p>
          <span className="testimonial-author">— Aisha K., Team Lead</span>
        </div>
      </div>
      <div className="testimonials-cta-row">
        <a href="/features" className="marketing-cta">See Features</a>
        <a href="/login" className="marketing-cta secondary">Get Started</a>
      </div>
    </div>
    <Footer />
  </>
);

export default Testimonials;
